import styled from '@emotion/styled';

interface TabContentProps {
	open: boolean;
}
interface TabStickyProps {
	isNotSticky: boolean;
}
export const TabListContainer = styled.div<TabStickyProps>`
	position: ${({ isNotSticky }) => (isNotSticky ? '' : 'sticky')};
	top: ${(props) => props.theme.heights.header};
	z-index: 9;
	display: flex;
	height: 5.2rem;
	background: ${(props) => props.theme.colors.surfacePage};
	max-width: 135rem;
	width: 100%;
	margin: 0 auto;
	@media screen and (max-width: ${(props) => props.theme.breakpoints.layout}px) {
		top: ${(props) => props.theme.heights.headerMobile};
	}
`;
export const TabListItem = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	flex: 1;
	border-bottom: 2px solid ${(props) => props.theme.colors.borderDefault};
	font-size: ${(props) => props.theme.fontSize.sizeLg};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	line-height: 1.35;
	letter-spacing: -0.03em;
	color: ${(props) => props.theme.colors.textMuted};
	cursor: pointer;
	transition:
		color ${(props) => props.theme.motion.duration.normal} ${(props) => props.theme.motion.easing.standard},
		border-color ${(props) => props.theme.motion.duration.normal} ${(props) => props.theme.motion.easing.standard},
		background-color ${(props) => props.theme.motion.duration.normal} ${(props) => props.theme.motion.easing.standard};
	:hover:not(.active) {
		color: ${(props) => props.theme.colors.textSecondary};
		background-color: ${(props) => props.theme.colors.primary50};
	}
	&.active {
		color: ${(props) => props.theme.colors.primary400};
		border-bottom: 2px solid ${(props) => props.theme.colors.primary400};
	}
`;
export const DropdownContainer = styled.div<TabStickyProps>`
	width: 100%;
	position: ${({ isNotSticky }) => (isNotSticky ? '' : 'sticky')}; // 여기!
	top: ${(props) => props.theme.heights.headerMobile};
	z-index: 9;
`;
export const DropdownWrapper = styled.div<TabStickyProps>`
	position: relative;
	display: flex;
	flex-direction: column; // 드롭다운이 아래로 쌓이도록
	border-top: 1px solid ${({ isNotSticky, theme }) => (isNotSticky ? theme.colors.borderDefault : '')};
`;
export const DropdownButton = styled.button`
	width: 100%;
	height: 5.2rem;
	padding: 0rem 2rem;
	background: ${(props) => props.theme.colors.surfacePage};
	border: none;
	border-bottom: 1px solid ${(props) => props.theme.colors.borderSubtle};
	cursor: pointer;
	display: flex;
	justify-content: space-between;
	align-items: center;
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	color: ${(props) => props.theme.colors.textPrimary};
	letter-spacing: -0.02em;
	transition: background-color ${(props) => props.theme.motion.duration.fast} ${(props) => props.theme.motion.easing.standard};
	:hover {
		background-color: ${(props) => props.theme.colors.surfaceMuted};
	}
`;
export const DropdownList = styled.ul<TabContentProps>`
	position: absolute;
	top: 5.2rem;
	width: 100%;
	background: ${(props) => props.theme.colors.surfacePage};
	border-bottom: 1px solid ${(props) => props.theme.colors.borderSubtle};
	border-radius: 0 0 ${(props) => props.theme.borderRadius.control} ${(props) => props.theme.borderRadius.control};
	list-style: none;
	padding: 0;
	display: ${({ open }) => (open ? 'block' : 'none')};
	overflow-y: auto;
	z-index: 10;
`;
export const DropdownItem = styled.li`
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: 1.45;
	letter-spacing: -0.02em;
	color: ${(props) => props.theme.colors.textSecondary};
	padding: 1.6rem 2rem;
	cursor: pointer;
	transition:
		color ${(props) => props.theme.motion.duration.fast} ${(props) => props.theme.motion.easing.standard},
		background-color ${(props) => props.theme.motion.duration.fast} ${(props) => props.theme.motion.easing.standard};
	&:hover {
		color: ${(props) => props.theme.colors.primary400};
		background-color: ${(props) => props.theme.colors.primary50};
	}
`;
export const ArrowDown = styled.div<TabContentProps>`
	padding-left: 0.4rem;
	transition: transform ${(props) => props.theme.motion.duration.normal} ${(props) => props.theme.motion.easing.standard};
	${({ open }) => open && 'transform: rotate(180deg);'}
`;
